import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Work from '../components/Work';
import Books from '../components/Books';
import Speaking from '../components/Speaking';
import Global360Child from '../components/Global360Child';
import BookMeeting from '../components/BookMeeting';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import PaymentStatus from '../components/PaymentStatus';

const Home = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Re-scroll to hash anchor after images/fonts finish loading so late-loading
  // content doesn't push the anchor off-screen (common on slow networks/mobile).
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    // Initial attempt
    const t1 = setTimeout(scrollToHash, 300);
    // After images/layout settle
    const t2 = setTimeout(scrollToHash, 1200);
    // Final re-align once window fully loaded
    window.addEventListener('load', scrollToHash);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener('load', scrollToHash);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PaymentStatus />
      <Navigation scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <About />
      <Gallery />
      <Work />
      <Books />
      <Speaking scrollToSection={scrollToSection} />
      <Global360Child scrollToSection={scrollToSection} />
      <BookMeeting />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
